import { render, staticRenderFns } from "./PfInterestWaiverForm.vue?vue&type=template&id=42b50cf8&scoped=true"
import script from "./PfInterestWaiverForm.vue?vue&type=script&lang=js"
export * from "./PfInterestWaiverForm.vue?vue&type=script&lang=js"
import style0 from "./PfInterestWaiverForm.vue?vue&type=style&index=0&id=42b50cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b50cf8",
  null
  
)

export default component.exports